import { storePriceLabel } from '../constants/stores';
import { useOptionalStorage } from '../contexts/StorageContext';

/**
 * 지금 매장의 "<매장> 가격" 이름(예: "광주 가격") — 가격 조회 쪽 용어(세 화면 재설계 C10, 감사 card-controltower#489).
 * PriceHub 가 이 매장에 준 판매가(옛 이름 수정가 · 추천가)를 이렇게 부른다. 네이버에 지금 걸린 값은 "네이버 가격".
 * 매장을 모르거나 StorageProvider 밖이면 "매장 가격".
 */
export function useStorePriceName(): string {
  const s = useOptionalStorage();
  return storePriceLabel(s ? (s.store ?? s.superStore) : null);
}
